import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link was generated.");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Link to="/"><Logo /></Link></div>
        <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
          <h1 className="font-heading text-2xl font-bold text-[#0F2747]">Reset your password</h1>
          {sent ? (
            <p className="mt-4 text-sm text-slate-600">
              If an account exists for <b>{email}</b>, a reset link has been generated. Check the
              server logs for the reset link (email delivery is not configured in this MVP).
            </p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" data-testid="forgot-email-input" value={email}
                  onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 rounded-xl" />
              </div>
              <Button type="submit" data-testid="forgot-submit-btn" className="w-full rounded-full bg-[#18A6A6] py-6 hover:bg-[#148f8f]">
                Send reset link
              </Button>
            </form>
          )}
          <p className="mt-6 text-center text-sm text-slate-500">
            <Link to="/login" className="font-semibold text-[#18A6A6]">Back to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
